import LocalForageProjectData, {
    LocalForageProjectDataShape,
} from './LocalForageProjectData';

export { type LocalForageProjectDataShape };
export default LocalForageProjectData;
